import qs from '../../scripts/util/dom/qs';
import qsc from '../../scripts/util/dom/qsc';
import isElement from '../../scripts/util/dom/isElement';
import addClass from '../../scripts/util/dom/addClass';
import rmc from '../../scripts/util/dom/rmc';


const selectors = {
	notice: '.js-notice',
	button: '.js-notice-close',
	wrapper: '.js-notice-wrapper'
};

const states = {
	show: 'notice_show',
	close: false
};

const notice = qsc(selectors.notice);
const wrapper = qsc(selectors.wrapper);

const setHeight = () => {
	const height = notice().clientHeight;
	wrapper().style.height = `${height}px`;
};

const close = () => {
	rmc(states.show, notice());
	wrapper().style.height = `0`;
};

const show = () => {
	setHeight();
	addClass(states.show, notice());
};

const updateContent = content => {
	notice().innerHTML = content;
};

const closeByClick = () => {
	states.close = true;
	close();
};

const isCloseByClick = () => states.close;

const render = () => {
	if (isElement(selectors.notice)) {
		qs(selectors.button).addEventListener('click', closeByClick);
		setHeight();
	}
};

export {
	show,
	updateContent,
	close,
	isCloseByClick
};

export default render;



/** WEBPACK FOOTER **
 ** ./app/blocks/notice/notice.js
 **/